
// 赋值：this.$store.commit('SET_AAA', 'aaa')
const app = {
  state: {
    device: 'desktop'
  },

  mutations: {
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
  },

  actions: {

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js